module.exports = __webpack_public_path__ + "img/language.8d021b9b.svg";